import { FlexDiv } from "src/common/styles/div";
import styled from "styled-components";

export const ContentContainer = styled(FlexDiv)`
    gap: 18px;
    padding-left: 18px;
    padding-right: 18px;
    padding-top: 20px;
    padding-bottom: 20px;
`